module.exports = __webpack_public_path__ + "static/media/time_night.34f99b71.svg";